module.exports = __webpack_public_path__ + "img/ipcc.87c937e0.png";